import { render, staticRenderFns } from "./AttachmentType.vue?vue&type=template&id=276946dc&scoped=true"
import script from "./AttachmentType.vue?vue&type=script&lang=ts"
export * from "./AttachmentType.vue?vue&type=script&lang=ts"
import style0 from "./AttachmentType.vue?vue&type=style&index=0&id=276946dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276946dc",
  null
  
)

export default component.exports